import React from 'react'

export default function InfoSection({ sectionLabel, children, fullWidth, marginBottom,noFlex,paddingTop }) {
  return (
    <div style={{ marginBottom: marginBottom || "16px", flex: noFlex ? 'none' : `0 0 ${fullWidth ? '100%' : '48%'}` }}>
      {sectionLabel && (
        <h6 style={{ color: "grey", margin: 0, paddingTop: paddingTop || 10 }}>{sectionLabel}</h6>
      )}
      <div style={{ marginTop: "8px" }}>{children}</div>
    </div>
  )
}
